const changeExecutorOrgDeniedCausePays = {
    title: 'Ошибка смены ОПФ',
    description:
        'Нельзя сменить правовую форму исполнителя, если у него есть <b>не исполненные акты</b>. Исправьте их и повторите попытку',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default changeExecutorOrgDeniedCausePays;
